import { Container, Row, Col } from "react-bootstrap";
import businessOpp from "../../../assets/images/icons/businessOpp2.jpg";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import ScheduleMeetingForm from "../../pages/knowMore/ScheduleMeetingForm";
export default function BusinessOpportunities() {
   const [showForm, setShowForm] = useState(false);
    const [showModal, setShowModal] = useState(false);
  
   const handleOpen = () => {
    setShowModal(true);
  };
  const handleFormClose = () => {
    setShowModal(false);
    setShowForm(false);
  };
  return (
    <section className="business_opportunity_wrap">
      <Container>
        <div className="testimonial_inner_wrap">
          <Row>
            <Col sm={6} md={6} lg={6} xl={7}>
              <div className="bussinessOpp-text">
               
Let’s collaborate to build intelligent solutions for tomorrow. As one of the leading blockchain development companies in Dubai, we’re open to strategic partnerships, product co-development, white-label services, and custom enterprise solutions that meet your specific business needs. Whether you're exploring automation, launching a startup, or modernizing legacy systems — Infograins is your ideal technology partner.

              </div>
              <button className="adpage_button_explore" onClick={handleOpen}>Explore</button>
            </Col>
            <Col sm={4} md={4} lg={4} xl={4}>
              <img
                src={businessOpp}
                alt="bussinessOpp"
                className="bussiness-opp-img"
              />
            </Col>
             <Col lg={6} md={12} sm={12}>
                              <div className="event_page_lead_form">
                                {showForm && <ScheduleMeetingForm error={0} />}
                              </div>
                            </Col>
          </Row>
        </div>
        
      </Container>
       <Modal show={showModal} onHide={handleFormClose} centered size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title>Schedule a Meeting</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="bg-white p-4 pop_up_schedule_form">
                      <ScheduleMeetingForm error={0} />
                    </Modal.Body>
                  </Modal>
    </section>
  );
}
